import Vue from 'vue'
import AppDialog from './AppDialog'

Vue.component(AppDialog.name, AppDialog)
